import { ReconciliationTransactionRepository } from '../repositories/reconciliation-transaction.repository';
import { ReconciliationTransactionRepositoryService } from '../repositories/reconciliation-transaction.service';

export const ReconciliationTransactionProvider = [
  {
    provide: ReconciliationTransactionRepository,
    useClass: ReconciliationTransactionRepositoryService,
  },
];
